import { useEffect } from "react";
import { Logo } from "@/components/site/Logo";
import { PolicySection } from "@/components/site/PolicySection";
import { POLICY_UPDATED, policyIntro, sections } from "@/content/privacyPolicy";

export default function PrivacyPolicy() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Privacy Policy | Aero Soft Solutions";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <header className="sky-wash border-b border-sky-100">
        <div className="mx-auto max-w-3xl px-5 pb-14 pt-10 sm:px-6">
          <Logo />
          <p className="mt-14 font-mono text-xs uppercase tracking-[0.25em] text-sky-700">Legal</p>
          <h1 className="mt-4 font-display text-4xl font-semibold tracking-[-0.03em] text-ink sm:text-5xl" data-testid="privacy-title">
            Privacy <span className="font-serif font-normal italic text-sky-600">Policy</span>
          </h1>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-slate-600" data-testid="privacy-updated">
            Last updated {POLICY_UPDATED}
          </p>
          <p className="mt-8 text-base leading-relaxed text-slate-700 md:text-lg" data-testid="privacy-intro">{policyIntro}</p>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 pb-20 sm:px-6">
        {sections.map((s) => (
          <PolicySection key={s.id} s={s} />
        ))}
      </main>
      <footer className="bg-[#071A2E] py-8 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} Aero Soft Solutions Pty Ltd · ABN 147 024 828 80
      </footer>
    </div>
  );
}
